<template>
    <div class="row">
        <div class="col-md-6">
            <card title="Datos del usuario">
                <form @submit.prevent="updateProfile" @keydown="updateUserForm.onKeydown($event)">

                    <!-- Name -->
                    <div class="form-group">
                      <input v-model="$v.updateUserForm.name.$model" :class="{ 'is-invalid': $v.updateUserForm.name.$error }" class="form-control" type="text" name="name" placeholder="Nombre">
                      <div v-if="!$v.updateUserForm.name.required && $v.updateUserForm.name.$error">Campo obligatorio</div>
                      <div v-if="!$v.updateUserForm.name.minLength && $v.updateUserForm.name.$error">El campo debe tener como minimo {{$v.updateUserForm.name.$params.minLength.min}} caracteres.</div>
                    </div>

                    <!-- Email -->
                    <div class="form-group">
                      <input v-model="$v.updateUserForm.email.$model" :class="{ 'is-invalid': $v.updateUserForm.email.$error }" class="form-control" type="email" name="email" placeholder="Email">
                      <div v-if="!$v.updateUserForm.email.required && $v.updateUserForm.email.$error">Campo obligatorio</div>
                      <div v-if="!$v.updateUserForm.email.email && $v.updateUserForm.email.$error">El email es invalido.</div>
                    </div>

                    <button type="submit" :disabled="updateUserForm.busy || $v.updateUserForm.$invalid" class="btn btn-primary btn-user btn-block">
                      Actualizar Perfil
                    </button>
                </form>
            </card>
        </div>
        <div class="col-md-6">
            <card title="Cambiar contraseña">
                <form @submit.prevent="updatePassword" @keydown="updatePasswordForm.onKeydown($event)">
                    <!-- Password -->
                    <div class="form-group">
                        <input v-model="$v.updatePasswordForm.password.$model" :class="{ 'is-invalid': $v.updatePasswordForm.password.$error }" class="form-control" type="password" name="password" placeholder="Contraseña">
                        <div v-if="!$v.updatePasswordForm.password.required && $v.updatePasswordForm.password.$error">Campo obligatorio</div>
                        <div v-if="!$v.updatePasswordForm.password.minLength && $v.updatePasswordForm.password.$error">El campo debe tener como minimo {{$v.updatePasswordForm.password.$params.minLength.min}} caracteres.</div>
                    </div>

                    <!-- Password Confirmation -->
                    <div class="form-group">
                        <input v-model="$v.updatePasswordForm.password_confirmation.$model" :class="{ 'is-invalid': $v.updatePasswordForm.password_confirmation.$error }" class="form-control" type="password" name="password_confirmation" placeholder="Confirmar Contraseña">
                        <div v-if="!$v.updatePasswordForm.password_confirmation.sameAsPassword && $v.updatePasswordForm.password_confirmation.$error">Las contraseñas no coinciden</div>
                    </div>
                    <v-button :loading="updatePasswordForm.busy || $v.updatePasswordForm.$invalid" class="btn btn-primary btn-user btn-block">
                        Cambiar contraseña
                    </v-button>
                </form>
            </card>
        </div>
    </div>
</template>

<script>
import Form from 'vform'
import swal from 'sweetalert2'
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs, email } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
    middleware: 'auth',
    layout: 'main-layout',
    mixins: [validationMixin],
    metaInfo () {
        return { title: 'Profile' }
    },
    computed: mapGetters({
        user: 'auth/user'
    }),
    data: () => ({
        updateUserForm: new Form({
            name: '',
            email: ''
        }),
        updatePasswordForm: new Form({
            password: '',
            password_confirmation: ''
        }),
    }),
    created () {
        // Fill the form with user data.
        this.updateUserForm.keys().forEach(key => {
            this.updateUserForm[key] = this.user[key]
        })
    },
    validations: {
        updateUserForm: {
            name: {
                required,
                minLength: minLength(3)
            },
            email: {
                email,
                required
            }
        },
        updatePasswordForm: {
            password: {
                required,
                minLength: minLength(6)
            },
                password_confirmation: {
                sameAsPassword: sameAs('password')
            }
        }
    },
    methods: {
        async updateProfile () {

            this.updateUserForm.busy = true
            // Validar Formulario   
            this.$v.updateUserForm.$touch()
            if (this.$v.updateUserForm.$invalid) {
                swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: 'El formulario contiene errores',
                    reverseButtons: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar'
                })
                this.updateUserForm.busy = true
                return false
            }
            
            // Register the user.
            this.$store.dispatch('auth/updateUserPassword', this.updateUserForm).then(() => {
                this.updateUserForm.busy = false
                swal.fire({
                    type: 'success',
                    toast: true,
                    text:  'El usuario se actualizó exitosamente',
                    timer: 3000,
                })
            }).catch(error => {
                this.updateUserForm.busy = false
                swal.fire({
                    type: 'error',
                    title: 'Error',
                    text:  error.message,
                    reverseButtons: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar'
                })
            })

        },
        async updatePassword () {

            this.updatePasswordForm.busy = true
            // Validar Formulario   
            this.$v.updatePasswordForm.$touch()
            if (this.$v.updatePasswordForm.$invalid) {
                swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: 'El formulario contiene errores',
                    reverseButtons: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar'
                })
                this.updatePasswordForm.busy = false
                return false
            }
            
            // Register the user.
            this.$store.dispatch('auth/updateUserPassword', this.updatePasswordForm.password).then(() => {
                this.updatePasswordForm.busy = false
                swal.fire({
                    type: 'success',
                    toast: true,
                    text:  'El password se actualizó exitosamente',
                    timer: 3000,
                })
            }).catch(error => {
                this.updatePasswordForm.busy = false
                swal.fire({
                    type: 'error',
                    title: 'Error',
                    text:  error.message,
                    reverseButtons: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar'
                })
            })

        }
    }
}
</script>
